import { createRequestId } from './client-state.js';
import { postToWorker, requestWorker } from './lifecycle.js';

export const symbolIndexWorkerClient = {
  enqueue(parentPath: string, filePath: string, priority: number, sequence?: number): void {
    postToWorker({ type: 'enqueue', parentPath, filePath, priority, sequence });
  },

  markLatestActive(parentPath: string, sequence: number): void {
    postToWorker({ type: 'markLatestActive', parentPath, sequence });
  },

  deferBackground(): void {
    postToWorker({ type: 'deferBackground' });
  },

  publishFileBrowserActivity(snapshot: {
    inFlightRequests: number;
    inFlightReads: number;
    lastActivityAt: number;
  }): void {
    postToWorker({ type: 'fileBrowserActivity', ...snapshot });
  },

  registerParent(parentPath: string): void {
    postToWorker({ type: 'registerParent', parentPath });
  },

  scheduleWarmup(parentPath: string): void {
    postToWorker({ type: 'scheduleWarmup', parentPath });
  },

  async buildFull(parentPath: string): Promise<{ fileCount: number; tagCount: number }> {
    const requestId = createRequestId('build');
    const response = await requestWorker<{
      type: 'buildComplete';
      requestId: string;
      fileCount: number;
      tagCount: number;
    }>({
      type: 'buildFull',
      requestId,
      parentPath,
    });
    return { fileCount: response.fileCount, tagCount: response.tagCount };
  },

  async updateFile(parentPath: string, relPath: string): Promise<void> {
    const requestId = createRequestId('update');
    await requestWorker<{ type: 'updateComplete'; requestId: string }>({
      type: 'updateFile',
      requestId,
      parentPath,
      relPath,
    });
  },

  async removeFile(parentPath: string, relPath: string): Promise<void> {
    const requestId = createRequestId('remove');
    await requestWorker<{ type: 'removeComplete'; requestId: string }>({
      type: 'removeFile',
      requestId,
      parentPath,
      relPath,
    });
  },

  async ensureFile(
    parentPath: string,
    filePath: string,
    opts?: { importDepth?: number },
  ): Promise<boolean> {
    const requestId = createRequestId('ensure');
    const response = await requestWorker<{ type: 'ensureComplete'; requestId: string; ready: boolean }>({
      type: 'ensureFile',
      requestId,
      parentPath,
      filePath,
      importDepth: opts?.importDepth,
    });
    return response.ready;
  },
};
